import { render, staticRenderFns } from "./pricing.vue?vue&type=template&id=43cccc1d&scoped=true&"
import script from "./pricing.vue?vue&type=script&lang=ts&"
export * from "./pricing.vue?vue&type=script&lang=ts&"
import style0 from "./pricing.vue?vue&type=style&index=0&id=43cccc1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cccc1d",
  null
  
)

export default component.exports